import { NgModule } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { XAxisTicksComponent } from './x-axis-ticks.component';
import { XAxisComponent } from './x-axis.component';

@NgModule({
   imports: [NgxChartsModule],
   declarations: [XAxisComponent, XAxisTicksComponent],
   exports: [XAxisComponent, XAxisTicksComponent],
})
export class XAxisModule {}
